import { PeriodicityEnum } from '@enums/periodicity.enum';

export const DISCOUNT_PERIODICITY_LABEL: Record<PeriodicityEnum, string> = {
  [PeriodicityEnum.unit]: '',
  [PeriodicityEnum.monthly]: 'mois',
  [PeriodicityEnum.quarterly]: 'trimestre',
  [PeriodicityEnum.halfYearly]: 'semestre',
  [PeriodicityEnum.annual]: 'an'
};

export const PLURAL_DISCOUNT_PERIODICITY_LABEL: Record<PeriodicityEnum, string> = {
  [PeriodicityEnum.unit]: '',
  [PeriodicityEnum.monthly]: 'mois',
  [PeriodicityEnum.quarterly]: 'trimestres',
  [PeriodicityEnum.halfYearly]: 'semestres',
  [PeriodicityEnum.annual]: 'ans'
};
